<template>
  <div id="app">
    <router-view/>
  </div>
</template>

<script>
export default {
  name: 'App'
}
</script>

<style>
html,
body {
  position: relative;
  /* width: 100%;
  height: 100%;
  overflow: hidden; */
  overflow: scroll;
  -webkit-overflow-scrolling: touch;
}

button,
input {
  border: none;
  outline: none;
  padding: 0;
}
#app {
  position: relative;
  width: 100%;
  height: 100%;
  font-family: "Avenir", Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  overflow: hidden;
}
</style>



// WEBPACK FOOTER //
// src/App.vue